import React, { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Form, Input, Button, Row, Col, Card, } from "antd";



const Search = ({ dispatch, initialFilters }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            title: initialFilters.title,
            news_type: initialFilters.news_type
        });
    }, [form, initialFilters]);


    const searchClickHandler = () => {
        const filter_click = {
            type: "set_clicked",
            payload: true,
        };
        dispatch(filter_click);
        const requestFilters = {
            title: form.getFieldValue("title") ? form.getFieldValue("title") : null,
        };
        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Card bodyStyle={{ paddingBottom: "0" }}>
                    <Form
                        layout="vertical"
                        labelAlign="left"
                        form={form}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                    >
                        <Row gutter={24} align="bottom">
                            <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item name="title" label="Titulli:">
                                    <Input
                                        name="title"
                                        placeholder="Titulli i lajmit..."
                                        className="w-100"
                                        size="medium"
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={3} lg={3} md={4} sm={24} xs={24} className="text-center mb-0">
                                <Form.Item>
                                    <Button
                                        block
                                        type="primary"
                                        size="medium"
                                        icon={<SearchOutlined />}
                                        onClick={() => searchClickHandler()}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
};


export default Search;